import axios from "axios";
import { APIresponse } from "../../model/client/response";
import { State } from "../../model/application/state";
import { store } from "../store";
import { APILoaderAction } from "../action/merchant";
import { UtilityConfig } from "../action/utility";
import hmacSHA512 from "crypto-js/hmac-sha512";

const initialState = new State.APILoader();

const GoBack = () => {
  window.location.href = window.location.origin;
};

export const GET = async (
  url: string,
): Promise<APIresponse.API> => {
  if (sessionStorage.getItem("*****")) {
    axios.defaults.headers.common["Authorization"] = ("Bearer " +
      sessionStorage.getItem("*****")) as string;
  }
    setState({ ...initialState, progressPercentange: 0, loading: true });
  let apiResponse = new APIresponse.API();
  apiResponse = await axios
    .get(url)
    .then((response) => {
      apiResponse = response.data;
      if (apiResponse.responseCode === "0" || apiResponse.responseCode === "00") {
          apiResponse.success = true;
          setState({ ...initialState, progressPercentange: 60, loading: false });
      } else {
        apiResponse.success = false;
        apiResponse.responseMessage = response.data.responseMessage;
        apiResponse.requestId = response.data.requestId
        apiResponse.transactionDateTime = response.data?.transactionDateTime
        setState({ ...initialState, progressPercentange: 60, loading: false });
          return apiResponse;
      }
      setState({ ...initialState, progressPercentange: 60, loading: false });
      return apiResponse;
    })
    .catch((error) => {
      if (error.response) {
        apiResponse.success = false;
        apiResponse.responseMessage =
          "Something went wrong. Please come back later.";
        apiResponse.responseCode = "01";
        return apiResponse;
      } else {
        apiResponse.success = false;
        apiResponse.responseMessage =
          "Service Unavailable. Please come back later.";
        apiResponse.responseCode = "10";
        setState({ ...initialState, progressPercentange: 60, loading: false });
        return apiResponse;
      }
    });
    setState({ ...initialState, progressPercentange: 60, loading: false });
  return apiResponse;
};


export const POST = async (
  url: string,
  request: any,
  token: string | null = null,
  formData: any | null = null
): Promise<APIresponse.API> => {
  if (token !== null) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    // axios.defaults.headers.common["Content-Type"] = "multipart/form-data"
    axios.defaults.data = formData
  }
  setState({ ...initialState, progressPercentange: 0, loading: true });
  let apiResponse = new APIresponse.API();
  apiResponse = await axios
    .post(url, request)
    .then(function (response) {
      apiResponse = response.data;

      if (response.data && response.data?.responseCode === "100") {
        apiResponse.success = false;
        apiResponse.responseCode = "100";
        apiResponse.responseMessage = response.data?.responseMessage;
        InfoModal({
          message: "You have been disabled from the system, kindly contact your administrator",
          logoutConfirmation: true,
          title: "User Disabled",
          data: {} as any,
          okText: "",
          cancelText: undefined,
          onOk: () => {
            window.location.href = localStorage.getItem("$$$$") ?? '';
          },
          onCancel: undefined,
          cancelButtonProps: { style: { display: "none" } },
        });
        return apiResponse;
      }
      if (
        apiResponse.responseCode === "0" ||
        apiResponse.responseCode === "00"
      ) {
        apiResponse.success = true;
      } else {
        apiResponse.success = false;
        if (
          apiResponse.responseCode === "01" ||
          apiResponse.responseMessage?.toLowerCase() === "pending"
        ) {
          apiResponse.pending = true;
        }
      }
      setState({ ...initialState, progressPercentange: 60, loading: false });
      return apiResponse;
    })
    .catch(function (error) {
      if (error.code && error.code === "ERR_NETWORK") {
        apiResponse.success = false;
        apiResponse.pending = true;
        apiResponse.responseCode = "16";
        apiResponse.responseMessage = error.message;
        return apiResponse;
      }
      if (error.code && error.response.data.responseCode === "97") {
        error.message = "";
        apiResponse.success = false;
        apiResponse.responseCode = "97";
        apiResponse.responseMessage = error.message;
        InfoModal({
          message: "You're not authorised",
          logoutConfirmation: true,
          title: "Access Denied",
          data: {},
          okText: "Return Home",
          cancelText: " ",
          onOk: () => {
            GoBack();
          },
          onCancel: () => { },
          cancelButtonProps: { style: { display: "none" } },
        });
        return apiResponse;
      }

      if (error.code && error.response.data.responseCode === "95") {
        apiResponse.success = false;
        apiResponse.responseCode = "95";
        apiResponse.responseMessage = String(error.response.data.responseMessage) || "You currently have another active session, kindly close this tab";
        InfoModal({
          message: apiResponse.responseMessage,
          logoutConfirmation: true,
          title: "Error!!!",
          data: {} as any,
          okText: "",
          cancelText: undefined,
          onOk: () => {
            sessionStorage.clear();
            window.location.href = '/';
          },
          onCancel: undefined,
          cancelButtonProps: { style: { display: "none" } },
        });
        return apiResponse;
      }
      if (!error.response) {
        apiResponse.success = false;
        apiResponse.pending = true;
        apiResponse.responseCode = "10";
        apiResponse.responseMessage =
          "Sorry, error from the server." +
          " We now know the mistake. We are working to fix it. Please try again later";
        return apiResponse;
      }
      if (!error.response) {
        apiResponse.success = false;
        apiResponse.pending = true;
        apiResponse.responseCode = "86";
        apiResponse.responseMessage = "Sorry, Merchant exist already.";
        return apiResponse;
      }
      apiResponse.success = false;
      apiResponse.pending = true;
      apiResponse.responseMessage = "Service Unvailable. Please try again.";
      apiResponse.responseCode = "99";
      if (error.response) {
        if (error.response.status === 404) {
          apiResponse.responseCode = "404";
        } else {
          apiResponse.responseCode = "99";
        }
        apiResponse.success = false;
        apiResponse.pending = true;
        apiResponse.responseMessage = Array.isArray(error.response.data)
          ? error.response.data.responseMessage
          : "";
        return apiResponse;
      }
      setState({ ...initialState, progressPercentange: 60, loading: false });
      return apiResponse;
    });
  setState({ ...initialState, progressPercentange: 60, loading: false });
  return apiResponse;
};
export const HMACSHA512DataEncryption = async (
  url: string,
  request: any,
  publicKey: string,
  privateKey: string
) => {
  let apiResponse = new APIresponse.API();
  const HMACSHA512 = hmacSHA512(JSON.stringify(request), privateKey);
  axios.defaults.headers.common["Authorization"] = "Bearer " + publicKey;
  axios.defaults.headers.common["PaymentHash"] = HMACSHA512 as any;

  apiResponse = await axios
    .post(url, request)
    .then((response) => {
      apiResponse = response.data;
      if (
        response.data.responseCode === "0" ||
        response.data.responseCode === "00"
      ) {
        apiResponse.success = true;
        return apiResponse;
      }

      if (response.data && response.data.responseCode === "91") {
        apiResponse.success = false;
        apiResponse.responseCode = response.data.responseCode;
        apiResponse.responseMessage = response.data.responseMessage;
        return apiResponse;
      }
      if (response.data && response.data.responseCode === "75") {
        apiResponse.success = false;
        apiResponse.responseCode = response.data.responseCode;
        apiResponse.responseMessage = response.data.responseMessage;
        return apiResponse;
      }
      if (response.data && response.data.responseCode === "51") {
        apiResponse.success = false;
        apiResponse.responseCode = response.data.responseCode;
        apiResponse.responseMessage = response.data.responseMessage;
        return apiResponse;
      }
      if (response.data && response.data.responseCode === "90") {
        apiResponse.success = false;
        apiResponse.responseCode = response.data.responseCode;
        apiResponse.responseMessage = response.data.responseMessage;
        return apiResponse;
      }
      if (response.data && response.data.responseCode === "96") {
        apiResponse.success = false;
        apiResponse.responseCode = response.data.responseCode;
        apiResponse.responseMessage = response.data.responseMessage;
        return apiResponse;
      }
      if (response.data && response.data.responseCode === "86") {
        apiResponse.success = false;
        apiResponse.responseCode = response.data.responseCode;
        apiResponse.responseMessage = response.data.responseMessage;
        return apiResponse;
      }
    })
    .catch((error) => (apiResponse = error.message));

  return apiResponse;
};

const setState = (state: State.APILoader) => {
  setTimeout(() => {
    store.dispatch({
      type: APILoaderAction.SET_API_LOADING_STATE,
      payload: state,
    });
  });
};

export const InfoModal = (state: State.Config) => {
  store.dispatch({
    type: UtilityConfig.Set_Utility_Config_State,
    payload: state,
  });
};
